module.exports = __webpack_public_path__ + "media/images/img-destination-df6a87baf745ebc82b42f6fa3386f683.svg";